import Vue from 'vue'

import {
  Carousel,
  CarouselItem,
  Breadcrumb,
  BreadcrumbItem,
  Form,
  FormItem,
  Radio,
  RadioGroup,
  Message,
  Input,
  Select,
  Option,
  Loading,
  InputNumber,
  Dialog,
  Button,
  Dropdown,
  DropdownMenu,
  DropdownItem,
  MessageBox,
  Table,
  TableColumn,
  Cascader,
  Popover,
  Scrollbar,
  Pagination,
  Tooltip,
  Checkbox,
} from 'element-ui';

Vue.use(Carousel);
Vue.use(CarouselItem);
Vue.use(Breadcrumb);
Vue.use(BreadcrumbItem);
Vue.use(Form);
Vue.use(FormItem);
Vue.use(RadioGroup);
Vue.use(Radio);
Vue.use(Input);
Vue.use(Select);
Vue.use(Option);
Vue.use(Loading);
Vue.use(InputNumber);
Vue.use(Dialog);
Vue.use(Button);
Vue.use(Dropdown);
Vue.use(DropdownMenu);
Vue.use(DropdownItem);
Vue.use(Table);
Vue.use(TableColumn);
Vue.use(Cascader);
Vue.use(Popover);
Vue.use(Scrollbar);
Vue.use(Pagination);
Vue.use(Tooltip);
Vue.use(Checkbox);

Vue.prototype.$message = Message;
Vue.prototype.$confirm = MessageBox.confirm;
// Element-ui官网上单独引用MessageBox的话需要在import中加入MessageBox。
Vue.prototype.$mb = MessageBox;
Vue.prototype.$alert = MessageBox.alert;


// WEBPACK FOOTER //
// ./src/element.js